import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "What's the smallest order you'll take?",
    a: "One piece. We take prototypes seriously — that's how a lot of our best long-term clients started.",
  },
  {
    q: "What file formats do you accept?",
    a: "DXF, DWG, STEP, SVG, AI, PDF. If you only have a sketch or photo, send it along — we'll redraw it for a small fee.",
  },
  {
    q: "How fast can you turn around an order?",
    a: "Standard lead time is 1–5 business days depending on complexity and material. Rush service available — just ask.",
  },
  {
    q: "Do you ship outside Southern California?",
    a: "Yes. We ship parts to all 50 states. Local pickup is welcome too.",
  },
  {
    q: "Can you handle production runs?",
    a: "Absolutely. We regularly run jobs from 100 to 10,000+ pieces with consistent quality and repeat-order pricing.",
  },
  {
    q: "Do you offer design help?",
    a: "Yes. If your file isn't laser-ready, we'll flag issues and suggest fixes before cutting. No engineering degree required.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      className="border-b border-zinc-800 bg-zinc-950 py-20 sm:py-28"
      data-testid="faq-section"
    >
      <div className="mx-auto max-w-5xl px-6">
        <p className="font-mono-spec mb-3 text-orange-500">// 05 — FAQ</p>
        <h2 className="font-display text-5xl text-white sm:text-6xl lg:text-7xl">
          Straight Answers.
          <br />
          <span className="text-zinc-500">No Runaround.</span>
        </h2>

        <Accordion
          type="single"
          collapsible
          className="mt-12 border-t border-zinc-800"
          data-testid="faq-accordion"
        >
          {faqs.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              className="border-b border-zinc-800"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger
                className="py-6 text-left font-display text-2xl text-white hover:text-orange-500 hover:no-underline sm:text-3xl"
                data-testid={`faq-trigger-${i}`}
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-base text-zinc-400 sm:text-lg">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
